import React from "react";

function UserGroupFormTable({children}) {
    return (
        <table className="user-group-edit-form__table">
            <colgroup>
                <col className="user-group-edit-form__col-label" />
                <col className="user-group-edit-form__col-value" />
                <col className="user-group-edit-form__col-label" />
                <col className="user-group-edit-form__col-value" />
            </colgroup>
            {children}
        </table>
    );
}

export default UserGroupFormTable;
